import { jobClusters } from './jobClusters';
import { jobProfiles } from './jobProfiles';
import { jobPayBands } from './jobPayBands';
import { jobPayRanges } from './jobPayRanges';
import { jobEmployments } from './jobEmployments';
import { externalPayRanges } from './externalPayRanges';
import { jobKeyValues } from './jobKeyValues';

export const jobArchitecture = {
    jobClusters,
    jobProfiles,
    jobPayBands,
    jobPayRanges,
    jobEmployments,
    externalPayRanges,
    jobKeyValues
};
